frappe.ui.form.ControlDate = class ControlDate extends frappe.ui.form.ControlData {
	static trigger_change_on_input_event = false;
	make_input() {
		super.make_input();
		this.make_picker();
	}
	make_picker() {
		this.set_date_options();
		this.set_datepicker();
		this.set_t_for_today();
	}
	set_formatted_input(value) {
		if (value === "Today") {
			value = this.get_now_date();
		}

		super.set_formatted_input(value);
		super.set_formatted_input(value);
		if (this.timepicker_only) return;
		if (!this.datepicker) return;
		if (!value) {
			this.datepicker.clear();
			return;
		}

		let should_refresh = this.last_value && this.last_value !== value;

		if (!should_refresh) {
			if (this.datepicker.selectedDates.length > 0) {
				// if date is selected but different from value, refresh
				const selected_date = moment(this.datepicker.selectedDates[0]).format(
					this.date_format
				);

				should_refresh = selected_date !== value;
			} else {
				// if datepicker has no selected date, refresh
				should_refresh = true;
			}
		}

		if (should_refresh) {
			this.datepicker.selectDate(frappe.datetime.str_to_obj(value));
		}
	}
	set_date_options() {
		// webformTODO:
		let sysdefaults = frappe.boot.sysdefaults;

		let lang = "en";
		frappe.boot.user && (lang = frappe.boot.user.language);
		if (!$.fn.datepicker.language[lang]) {
			lang = "en";
		}

		let date_format =
			sysdefaults && sysdefaults.date_format ? sysdefaults.date_format : "yyyy/mm/dd";
		sysdefaults && sysdefaults.date_format ? sysdefaults.date_format : "yyyy/mm/dd";

		this.today_text = __("Today");
		this.date_format = frappe.defaultDateFormat;
		this.datepicker_options = {
			language: lang,
			autoClose: true,
			todayButton: true,
			dateFormat: date_format,
			startDate: this.get_start_date(),
			keyboardNav: false,
			minDate: this.df.min_date,
			maxDate: this.df.max_date,
			firstDay: frappe.datetime.get_first_day_of_the_week_index(),
			onSelect: () => {
				this.$input.trigger("change");
			},
			onShow: () => {
				this.datepicker.$datepicker
					.find(".datepicker--button:visible")
					.text(this.today_text);

				this.update_datepicker_position();
			},
			...this.get_df_options(),
		};
	}

	get_start_date() {
		return this.get_now_date();
	}

	set_datepicker() {
		// alert("frappe.boot.user.persian")
		function persianToLatinDigits(persianText) {
			const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
			const latinDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

			let latinText = persianText;
			for (let i = 0; i < 10; i++) {
				const persianDigitRegExp = new RegExp(persianDigits[i], "g");
				latinText = latinText.replace(persianDigitRegExp, latinDigits[i]);
			}

			return latinText;
		}

		const todayDate = () => {
			const today = new Date();
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, "0");
			const day = String(today.getDate()).padStart(2, "0");
			return `${year}-${month}-${day}`;
		};

		this.$input.on("keydown", (e) => {
			if (e.key === " ") {
				e.preventDefault(); // Prevent default space character
				const date = todayDate();
				this.$input.val(date);
				this.$input.trigger("change");
			}
		});

		if (frappe.boot.user.language == 'fa') {
			this.$input.persianDatepicker({
				format: 'YYYY-MM-DD',
				// inline:true,
				autoClose: true,
				initialValue: false,
				persianDigit: false,
				// responsive: true,
				calendarType: 'persian',
				toolbox: {
					calendarSwitch: {
						enabled: false
					},
					todayButton: {
						enabled: false
					}

				},
				calendar: {
					persian: {
						locale: 'en',
						leapYearMode: 'astronomical'
					}
				},
				// onSelect: () => {
				// 	const selectedDate = this.$input.val();
				// 	if (selectedDate) {
				// 		const latinSelectedDate = persianToLatinDigits(selectedDate);
				// 		const [latinYear, latinMonth, latinDay] = latinSelectedDate.split(/[-/]/).map(Number);
				// 		const gregorianDate = jalaali.toGregorian(latinYear, latinMonth, latinDay);
				// 		const final_gregorianDate = `${gregorianDate.gy}-${String(gregorianDate.gm).padStart(2, "0")}-${String(gregorianDate.gd).padStart(2, "0")}`;
				// 		this.$input.val(final_gregorianDate);
				// 		this.$input.trigger("change");
				// 	}
				// }
				onSelect: (unix) => {
					const selectedDate = this.$input.val();
					if (selectedDate) {
						// Keep Persian format visible in input
						const latinSelectedDate = persianToLatinDigits(selectedDate);
						this.$input.val(latinSelectedDate);
						// Trigger change so backend gets Gregorian through `parse()`
						this.$input.trigger("change");
					}
				},
				// onShow: () => {
				// 	this.$input.val("تاریخ را انتخاب کنید");
				// },
			});
			// ".content, .main-section, .navbar, .no-breadcrumbs"
			// 	$(window).on('mouseenter', () => {
			// 		const selectedDate = this.$input.val();
			// 		const [latinYear, latinMonth, latinDay] = selectedDate.split(/[-/]/).map(Number);
			// 		if (latinYear >= 1800){
			// 		const jalaaliDate = jalaali.toJalaali(latinYear, latinMonth, latinDay);
			// 		const final_jalaaliDate = `${jalaaliDate.jy}-${String(jalaaliDate.jm).padStart(2, "0")}-${String(jalaaliDate.jd).padStart(2, "0")}`;
			// 		if (jalaaliDate.jy >= 1000) {
			// 			// alert(frappe.local.request)
			// 			this.$input.val(final_jalaaliDate);
			// 	}
			// }
			// 	});

			// function convertAndShowDate($input) {
			// 	alert("hi")
			// 	return function() {
			// 		const selectedDate = $input.val();
			// 		const [latinYear, latinMonth, latinDay] = selectedDate.split(/[-/]/).map(Number);
			// 		if (latinYear >= 1800) {
			// 			const jalaaliDate = jalaali.toJalaali(latinYear, latinMonth, latinDay);
			// 			const final_jalaaliDate = `${jalaaliDate.jy}-${String(jalaaliDate.jm).padStart(2, "0")}-${String(jalaaliDate.jd).padStart(2, "0")}`;
			// 			if (jalaaliDate.jy >= 1000) {
			// 				$input.val(final_jalaaliDate);
			// 			}
			// 		}
			// 	};
			// }

			// // Initial execution when the DOM is ready
			// $(document).ready(function() {
			// 	const $input = this.$input; // Replace with the actual jQuery element

			// 	// Repeatedly execute every second
			// 	setInterval(convertAndShowDate($input), 1000);
			// });

		}

		else {
			this.$input.persianDatepicker({
				format: 'YYYY-MM-DD',
				// inline:true,
				autoClose: true,
				initialValue: false,
				persianDigit: false,
				calendarType: 'gregorian',
				toolbox: {
					calendarSwitch: {
						enabled: false
					}
				},
				calendar: {
					persian: {
						locale: 'en'
					}
				},
				onSelect: () => {
					const selectedDate = this.$input.val();
					if (selectedDate) {
						const [year, month, day] = selectedDate.split(/[-/]/).map(Number);
						const processedDate = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
						this.$input.val(processedDate);
						this.$input.trigger("change");
					}
				},
			});
		}
	}

	update_datepicker_position() {
		if (!this.frm) return;
		// show datepicker above or below the input
		// based on scroll position
		// We have to bodge around the timepicker getting its position
		// wrong by 42px when opening upwards.
		const $header = $(".page-head");
		const header_bottom = $header.position().top + $header.outerHeight();
		const picker_height = this.datepicker.$datepicker.outerHeight() + 12;
		const picker_top = this.$input.offset().top - $(window).scrollTop() - picker_height;

		var position = "top left";
		// 12 is the default datepicker.opts[offset]
		if (picker_top <= header_bottom) {
			position = "bottom left";
			if (this.timepicker_only) this.datepicker.opts["offset"] = 12;
		} else {
			// To account for 42px incorrect positioning
			if (this.timepicker_only) this.datepicker.opts["offset"] = -30;
		}

		this.datepicker.update("position", position);
	}

	get_now_date() {
		return frappe.datetime
			.convert_to_system_tz(frappe.datetime.now_date(true), false)
			.toDate();
	}

	set_t_for_today() {
		var me = this;
		this.$input.on("keydown", function (e) {
			if (e.which === 84) {
				// 84 === t
				if (me.df.fieldtype == "Date") {
					me.set_value(frappe.datetime.nowdate());
				}
				if (me.df.fieldtype == "Datetime") {
					me.set_value(frappe.datetime.now_datetime());
				}
				if (me.df.fieldtype == "Time") {
					me.set_value(frappe.datetime.now_time());
				}
				return false;
			}
		});
	}



	// parse(value) {
	// 	if (value) {
	// 		if (value == "Invalid date") {
	// 			return "";
	// 		}
	// 		return frappe.datetime.user_to_str(value, false, true);
	// 	}
	// }

	parse(value) {
		if (value) {
			const selectedDate = value;
			const [latinYear, latinMonth, latinDay] = selectedDate.split(/[-/]/).map(Number);
			if (latinYear >= 1800) {
				const jalaaliDate = jalaali.toJalaali(latinYear, latinMonth, latinDay);
				const final_jalaaliDate = `${jalaaliDate.jy}-${String(jalaaliDate.jm).padStart(2, "0")}-${String(jalaaliDate.jd).padStart(2, "0")}`;
				if (jalaaliDate.jy >= 1000) {
					return value;
				}
			}
			const latinSelectedDate = value;
			const [latinYear1, latinMonth1, latinDay1] = latinSelectedDate.split(/[-/]/).map(Number);
			const gregorianDate = jalaali.toGregorian(latinYear1, latinMonth1, latinDay1);
			const final_gregorianDate = `${gregorianDate.gy}-${String(gregorianDate.gm).padStart(2, "0")}-${String(gregorianDate.gd).padStart(2, "0")}`;
			return final_gregorianDate;
		}
	}

	format_for_input(value) {
		if (value) {

			let gregorianDate = frappe.datetime.str_to_user(value, false, true);

			// Check for invalid date
			if (gregorianDate === "Invalid date") {
				return "";
			}

			// Split Gregorian date into parts
			const [gy, gm, gd] = gregorianDate.split(/[-/]/).map(Number);

			// Convert to Jalaali
			const jDate = jalaali.toJalaali(gy, gm, gd);

			// Format as Persian date string
			const final_jalaali = `${jDate.jy}-${String(jDate.jm).padStart(2, '0')}-${String(jDate.jd).padStart(2, '0')}`;


			return final_jalaali;
		}
		return "";
	}

	// validate(value) {
	// 	if (value && !frappe.datetime.validate(value)) {
	// 		let sysdefaults = frappe.sys_defaults;
	// 		let date_format =
	// 			sysdefaults && sysdefaults.date_format ? sysdefaults.date_format : "yyyy/mm/dd";
	// 		frappe.msgprint(__("Date {0} must be in format: {1}", [value, date_format]));
	// 		return "";
	// 	}
	// 	return value;
	// }

	validate(value) {
		const dateRegex = /^\d{4}[-\/]\d{2}[-\/]\d{2}$/;

		if (value && !dateRegex.test(value)) {
			frappe.msgprint(__("The date must be in the format: yyyy-mm-dd Or yyyy/mm/dd"));
			return "";
		}

		return value;
	}

	// validate(value) {
	// 	const dateRegex = /^\d{4}[-\/]\d{2}[-\/]\d{2}$/;

	// 	// if (value && !dateRegex.test(value)) {
	// 	// 	frappe.msgprint(__("Date must be in format: yyyy-mm-dd or yyyy/mm/dd"));
	// 	// 	return "";
	// 	// }
	// 	if (value === null) {
	// 		// frappe.msgprint(__("null"));
	// 		return "";
	// 	} else if (value == '') {
	// 		frappe.msgprint(__("Date must be in format: yyyy-mm-dd or yyyy/mm/dd"));
	// 		return "";
	// 	}

	// 	return value;
	// }


	get_df_options() {
		let df_options = this.df.options;
		if (!df_options) return {};

		let options = {};
		if (typeof df_options === "string") {
			try {
				options = JSON.parse(df_options);
			} catch (error) {
				console.warn(`Invalid JSON in options of "${this.df.fieldname}"`);
			}
		} else if (typeof df_options === "object") {
			options = df_options;
		}
		return options;
	}


};
